import { render } from "./MatchDayTimeline.vue?vue&type=template&id=5f0f37d7&scoped=true"
import script from "./MatchDayTimeline.vue?vue&type=script&lang=js"
export * from "./MatchDayTimeline.vue?vue&type=script&lang=js"

import "./MatchDayTimeline.vue?vue&type=style&index=0&id=5f0f37d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0f37d7"]])

export default __exports__